<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <!-- Per Page -->
          <list-per-page
            :total="total"
            :current-per-page="perPage"
            @onChangePerPage="changePerPage"
          />
          <b-button
            v-if="$can('create','roles')"
            variant="success"
            @click="createButtonClicked"
          >
            {{ $t('Create role') }}
            <feather-icon icon="PlusIcon" />
          </b-button>
        </b-col>
        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <list-search @onSearch="search" />
          </div>
        </b-col>
      </b-row>
    </div>
    <table-loader v-if="loader" />
    <roles-list
      v-else
      :fields="fields"
      :items="items"
      :additional-data="additionalData"
    />

    <list-pagination
      :current="page"
      :current-per-page="perPage"
      :from="from"
      :to="to"
      :total="total"
      :total-page="totalPage"
      @onChangePage="changePage"
    />
  </b-card>
</template>

<script>
import { ListIndex } from '../../../common/mixins/list'
import RolesList from '../../../components/admin/roles/list/RolesList'

export default {
  components: {
    RolesList,
  },
  mixins: [ListIndex],
  data() {
    return {
      routeName: 'roles',
      adminFields: [
        {
          key: 'name',
          label: this.$t('Name'),
        },
        {
          key: 'slug',
          label: this.$t('Slug'),
        },
        {
          key: 'level',
          label: this.$t('Level'),
        },
        {
          key: 'action',
          label: '',
        },
      ],
    }
  },
}
</script>

<style lang="scss">

</style>
